import RenderTemplate from '../RenderTemplate'
import firstStepsApi from '../../utils/firstStepsApi'

const KitLegal = () => (
    <RenderTemplate
        fetchFn={firstStepsApi.getLegalTermsKitText}
        component="div"
        display="block"
        color="primary"
        variant="body2"
    />
)

export default KitLegal
